import request from '@/router/axios'
import qs from 'qs'
export function roleList() {
  return request({
    url: '/admin/role/roleList',
    method: 'get'
  })
}
export function fetchList(query) {
  return request({
    url: '/workerGroup/getMyGroups',
    method: 'post',
    params: query
  })
}
export function deptRoleList(deptId) {
  return request({
    url: '/admin/role/roleList/' + deptId,
    method: 'get'
  })
}
// 添加
export function addObj(obj) {
  return request({
    url: '/workerGroup/createGroup',
    method: 'post',
    params: obj
  })
}

// 编辑
export function getObj(groupId) {
  return request({
    url: '/workerGroup/groupInfo',
    method: 'post',
    params: groupId
  })
}
// 编辑修改
export function putObj(obj) {
  return request({
    url: '/workerGroup/updateGroup',
    method: 'post',
    params: obj
  })
}
// 删除
export function delObj(groupId) {
  return request({
    url: '/workerGroup/delGroup',
    method: 'post',
    params: groupId
  })
}
export function del1Obj(obj) {
    return request({
      url: '/workerGroup/delGroupWorker',
      method: 'post',
      params: obj
    })
  }
// 查看工人
export function allotObj(groupId) {
  return request({
    url: '/workerGroup/getGroupWorkers',
    method: 'post',
    params: groupId
  })
}
export function fetchList1(query) {
    return request({
      url: '/workerGroup/getMyWorkers',
      method: 'post',
      params: query
    })
  }
// 查看工人  添加 确定
export function addsObj                              
(obj) {
  return request({
    url: '/workerGroup/groupAddWorker',
    method: 'post',
    params: obj
  })
}
// 向群组添加工人
export function workerAddGroup(obj) {
  return request({
    url: '/workerGroup/workerAddGroup',
    method: 'post',
    params: obj
  })
}
// 更新/role/roleMenuUpd
export function permissionUpd(obj) {
  return request({
    url: '/role/roleMenuUpd',
    method: 'post',
    params: obj,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// 权限
export function fetchRoleTree(query) {
  return request({
    url: '/menu/roleTree',
    method: 'post',
    params: query
  })
}
// 部门
export function fetchDeptTree(query) {
  return request({
    url: '/dept/tree',
    method: 'post',
    params: query
  })
}
